import {Component, EventEmitter, Input, Output} from '@angular/core';

@Component({
  selector: 'daily-log-external-change-notification',
  templateUrl: 'daily-log-external-change-notification.component.html'
})
export class DailyLogExternalChangeNotificationComponent {
  @Input() pending = false;
  @Input() pulling = false;
  @Input() pullError = '';
  @Output() actionRequested = new EventEmitter<void>();
}



// WEBPACK FOOTER //
// ./src/pages/daily-log/components/daily-log-external-change-notification/daily-log-external-change-notification.component.ts